import { CERealizationBase } from './ce-realization-base'


export class CERealization extends CERealizationBase {

}